import { client, queries } from 'apollo';
import FlagOption from 'components/FlagOption/FlagOption';
import FlagPlaceholder from 'components/FlagPlaceholder/FlagPlaceholder';
import withColorQuery, { WithColorQueryProps } from 'enhancers/withColorQuery';
import withCountry, { IWithCountryProps } from 'enhancers/withCountry';
import withLanguageState, { WithLanguageProps } from 'enhancers/withLanguageState';
import * as React from 'react';
import Select from 'react-select/lib/Async';
import styled from 'styled-components';

interface IOption<T> {
  value: T;
  label: string;
}
interface ICountryQueryResponse {
  fetch: {
    Countries: Array<{ Name: string; UrlKey: string }>;
  };
}

interface IVariables {
  filters: {
    custom: string;
  };
}

interface IProps {
  value: IOption<string> | false;
  onChange: (option: IOption<string>) => void;
  className?: string;
  withFlag?: boolean;
}

interface IState {
  search: string;
}

type Props = IProps &
  WithColorQueryProps &
  IWithCountryProps &
  WithLanguageProps;

export class CountrySelector extends React.Component<Props, IState> {
  public state = {
    search: ''
  };
  public render() {
    const { props } = this;
    const loadOptions = () =>
      client
        .query<ICountryQueryResponse, IVariables>({
          query: queries.GET_COUNTRY_NAMES,
          variables: {
            filters: {
              custom: `data[*Name~/.*${this.state.search}.*/i&Active=yes]`
            }
          }
        })
        .then(result => {
          const options = result.data.fetch.Countries.map(country => ({
            label: country.Name,
            value: country.UrlKey
          })).sort((a, b) => {
            if (a.value === 'global') {
              return -1;
            }
            if (b.value === 'global') {
              return 1;
            }
            return 0;
          });
          return options;
        });

    const onInputChange = (input: string) => {
      this.setState({ search: input });
    };

    return (
      <Container>
        <StyledSelect
          cacheOptions={true}
          defaultOptions={true}
          loadOptions={loadOptions}
          inputValue={this.state.search}
          onInputChange={onInputChange}
          onChange={props.onChange}
          components={
            props.withFlag
              ? { Option: FlagOption, SingleValue: FlagPlaceholder }
              : {}
          }
          value={props.value}
          className={props.className}
        />
      </Container>
    );
  }
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const StyledSelect = styled(Select)`
  min-width: 250px;
`;

export default withLanguageState(withCountry(withColorQuery(CountrySelector)));



// WEBPACK FOOTER //
// ./src/components/CountrySelector/CountrySelector.tsx